<template>
    <div class="relative z-10 flex justify-center bg-yellow-325 p-4 text-xs">
        <div class="flex items-center gap-x-2 text-blue-800 font-medium">
            <div class="h-4 w-4">
                <AlertIcon  />
            </div>

            <div>
                Due to maintenance, some services will be temporarily unavailable. We apologize for any inconvenience
            </div>
        </div>
    </div>
</template>
<script setup>
import AlertIcon from '@/components/icons/alert/AlertIcon.vue'
</script>
